/**
 * Encryption utilities to match PHP backend encryption
 * Must match the encrypt() and decrypt() functions in portal/app/Helpers/Utility.php
 */

// Encryption key - must match KEY constant in portal/app/Config.php
const KEY = "p0o9i8u78i9o0p";

/**
 * Base64 URL-safe encoding (matches PHP base64_url_encode)
 * Converts standard base64 to URL-safe format by replacing +/= with -_,
 */
function base64UrlEncode(str) {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, ',');
}

/**
 * Base64 URL-safe decoding (matches PHP base64_url_decode)
 * Converts URL-safe base64 back to standard format
 */
function base64UrlDecode(str) {
  str = str.replace(/-/g, '+').replace(/_/g, '/').replace(/,/g, '=');
  return atob(str);
}

/**
 * Encrypt a string to match PHP encrypt() function
 * 
 * PHP implementation:
 * function encrypt($string) {
 *   $result = '';
 *   for($i=0, $k=strlen($string); $i<$k; $i++) {
 *     $char = substr($string, $i, 1);
 *     $keychar = substr(KEY, ($i % strlen(KEY))-1, 1);
 *     $char = chr(ord($char)+ord($keychar));
 *     $result .= $char;
 *   }
 *   return base64_url_encode($result);
 * }
 */
export function encrypt(string) {
  let result = '';
  const strValue = String(string); // Convert to string in case it's a number
  
  for (let i = 0; i < strValue.length; i++) {
    const char = strValue.charAt(i);
    const keyIndex = (i % KEY.length) - 1;
    const keyChar = keyIndex < 0 ? KEY.charAt(KEY.length - 1) : KEY.charAt(keyIndex);
    
    const encryptedCharCode = char.charCodeAt(0) + keyChar.charCodeAt(0);
    result += String.fromCharCode(encryptedCharCode);
  }
  
  return base64UrlEncode(result);
}

/**
 * Decrypt a string (for testing purposes)
 * 
 * PHP implementation:
 * function decrypt($string) {
 *   $result = '';
 *   $string = base64_url_decode($string);
 *   for($i=0,$k=strlen($string); $i<$k; $i++) {
 *     $char = substr($string, $i, 1);
 *     $keychar = substr(KEY, ($i % strlen(KEY))-1, 1);
 *     $char = chr(ord($char)-ord($keychar));
 *     $result.=$char;
 *   }
 *   return $result;
 * }
 */
export function decrypt(encryptedString) {
  let result = '';
  const decoded = base64UrlDecode(encryptedString);
  
  for (let i = 0; i < decoded.length; i++) {
    const char = decoded.charAt(i);
    const keyIndex = (i % KEY.length) - 1;
    const keyChar = keyIndex < 0 ? KEY.charAt(KEY.length - 1) : KEY.charAt(keyIndex);
    
    const decryptedCharCode = char.charCodeAt(0) - keyChar.charCodeAt(0);
    result += String.fromCharCode(decryptedCharCode);
  }
  
  return result;
}
